<template>
  <div class="ci">
    <label v-if="label" class="ci__label">{{ label }}</label>
    <input
        class="ci__input"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
        @blur="$emit('blur', $event.target.value)"
    />
  </div>
</template>

<script>
/**
 * Reusable text input — label + rounded field, fully styled by us (no vue-material).
 * v-model driven.
 *
 * Props: value (v-model), label, placeholder, type ('text'|'email'|...), disabled
 */
export default {
  name: 'CustomInput',
  props: {
    value: { default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    type: { type: String, default: 'text' },
    disabled: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.ci { display: flex; flex-direction: column; min-width: 0; width: 100%; }
.ci__label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #555;
  margin-bottom: 0.3rem;
}
.ci__input {
  width: 100%;
  height: 44px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  background: #fafafa;
  padding: 0 0.85rem;
  font-size: 0.9rem;
  color: #202224;
  box-sizing: border-box;
  transition: border-color .15s ease, background .15s ease;
}
.ci__input::placeholder { color: #9aa0a6; }
.ci__input:hover { border-color: #c2c2c2; }
.ci__input:focus { outline: none; border-color: #999; background: #fff; }
.ci__input:disabled { opacity: 0.6; cursor: not-allowed; }
</style>
